// extracted by mini-css-extract-plugin
export default {"not-favorite":"HeartButton_not-favorite__N6SZx","favorite":"HeartButton_favorite__HOJhN"};